import React from 'react';
import { Block } from 'factories/block';
import getBlockById from './getBlockById';

// TODO
// implement something like this
interface IRender {
  [key: string]: (props?: any) => {} | null;
}

const render = (block: Block, Components: {}): JSX.Element | string => {
  let b: Block | null = block;
  //
  if (b?.type === 'Ref') {
    b = b?.id ? getBlockById(b.id) : null;
  }

  if (!b) {
    return <div key={`block-is-void-${Math.random()}`} />;
  }

  const children = Array.isArray(b.children)
    ? (b.children as Block[]).map(c => render(c, Components))
    : b.children;

  let Component = Components[b.type];

  if (Component === null) {
    // we can run this check here
    // or we ' enforce ' the function with types
    // yes. let's TODO that
    Component = () => null;
  } else if (!Component) {
    Component = () => null;
  }

  return (
    <Component key={b.id} id={b.id} {...b.props}>
      {children}
    </Component>
  );
};

export default render;
